// extracted by mini-css-extract-plugin
export default {"submitButton":"RectangleButton-module__submitButton--sXwig","active":"RectangleButton-module__active--NFLNe","disabled":"RectangleButton-module__disabled--CjJ8P"};